import {
    PaybisUpdateKybTcStatusData,
    PaybisUpdateKybTcStatusResponse,
} from "./types"
import CommonApiError from "../../../errors/CommonApiError"
import parseHttpApiError from "../../../utils/parseHttpApiError"
import { PaybisUpdateKybTcStatusDocument } from "../../__generated__/graphql"
import apolloClient, { normalizeApolloError } from "../../apolloClient"
import { IGQLApiError } from "../../types"

export const paybisUpdateKybTcStatus = async (
    data: PaybisUpdateKybTcStatusData
): Promise<PaybisUpdateKybTcStatusResponse> => {
    const variables = {
        companyId: data.companyId,
        tcStatus: data.tcStatus,
    }

    try {
        const result = await apolloClient.mutate({
            context: {
                headers: {
                    Authorization: `Bearer ${data.accessToken}`,
                },
            },
            fetchPolicy: "no-cache",
            mutation: PaybisUpdateKybTcStatusDocument,
            variables,
        })
        return { data: result.data! }
    } catch (err: unknown) {
        const error = normalizeApolloError(err)
        if (error instanceof CommonApiError) {
            throw parseHttpApiError(error.body as IGQLApiError[])
        }
        throw error
    }
}
